import { render, staticRenderFns } from "./tabComparative.vue?vue&type=template&id=2dc36ea0&"
import script from "./tabComparative.vue?vue&type=script&lang=js&"
export * from "./tabComparative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports